import { render, staticRenderFns } from "./UnidentifiedObjectSafe.vue?vue&type=template&id=60f6963e&"
import script from "./UnidentifiedObjectSafe.vue?vue&type=script&lang=js&"
export * from "./UnidentifiedObjectSafe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports